import BaseModel from '../../base';

import constants, { MANAGED_KEY } from './constants';
import glossary, { MANAGED_DATA } from './glossary';
import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import { getInviteLink } from '@/modules/UIDesign/Invites/functions';
import { INVITE_TYPE } from '@/modules/UIDesign/Invites/constants';
import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';

export default class AssociationOffice extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);

    this.event_association_id = item.event_association_id;
    this.manager_id = item.manager_id;
    this.owner_id = item.owner_id;

    this.is_active = item.is_active;
    this.clubs_count = item.clubs_count;
    this.active_users_count = item.active_users_count;

    this.event_association = item.event_association;
    this.owner = item.owner;
    this.manager = item.manager;
    this.regions = item.regions || [];
    this.municipalities = item.municipalities || [];
    this.clubs = item.clubs || [];
  }

  get managedKey() {
    const { manager_id } = this;
    return manager_id ? MANAGED_KEY.manager : MANAGED_KEY.empty;
  }

  get managedData() {
    return MANAGED_DATA[this.managedKey];
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }

  get api() {
    const { url, id } = this;
    const path = `${url}/${id}`;
    return {
      get inviteLink() {
        const getMethod = (methodType) => rHandler(
          apiService?.[methodType]?.(`${path}/invite`),
          (response) => ({
            response,
            item: getInviteLink(response?.data?.data?.invite || '', INVITE_TYPE.associationOffice),
          }),
          (error) => ({ error }),
        );
        return {
          get: () => getMethod('get'),
          refresh: () =>  getMethod('post'),
        };
      },
      get municipalities() {
        const currentPath = `${path}/municipalities`;
        return {
          attach({ data } = DEFAULT_PARAMS) {
            return rHandler(
              apiService.post(`${currentPath}`, data),
              (response) => ({
                response,
                item: response.data.data,
              }),
              (error) => ({ error }),
            );
          },
          detach({ data } = DEFAULT_PARAMS) {
            return rHandler(
              apiService.post(`${currentPath}/detach`, data),
              (response) => ({
                response,
                item: response.data.data,
              }),
              (error) => ({ error }),
            );
          },
        };
      },
      get regions() {
        const currentPath = `${path}/regions`;
        return {
          attach({ data } = DEFAULT_PARAMS) {
            return rHandler(
              apiService.post(`${currentPath}`, data),
              (response) => ({
                response,
                item: response.data.data,
              }),
              (error) => ({ error }),
            );
          },
          detach({ data } = DEFAULT_PARAMS) {
            return rHandler(
              apiService.post(`${currentPath}/detach`, data),
              (response) => ({
                response,
                item: response.data.data,
              }),
              (error) => ({ error }),
            );
          },
        };
      },
      get manager() {
        return {
          detach({ data } = DEFAULT_PARAMS) {
            return rHandler(
              apiService.post(`${path}/detach-manager`, data),
              (response) => ({
                response,
                item: response.data.data,
              }),
              (error) => ({ error }),
            );
          },
        };
      },
      enable() {
        return rHandler(
          apiService.post(`${path}/enable`),
          (response) => ({
            response,
            item: response.data.data,
          }),
          (error) => ({ error }),
        );
      },
      disable() {
        return rHandler(
          apiService.post(`${path}/disable`),
          (response) => ({
            response,
            item: response.data.data,
          }),
          (error) => ({ error }),
        );
      },
      get clubs() {
        const currentPath = `${path}/clubs`;
        return {
          attach({ data } = DEFAULT_PARAMS) {
            return rHandler(
              apiService.post(`${currentPath}`, data),
              (response) => ({
                response,
                item: response.data.data,
              }),
              (error) => ({ error }),
            );
          },
          detach({ data } = DEFAULT_PARAMS) {
            return rHandler(
              apiService.post(`${currentPath}/detach`, data),
              (response) => ({
                response,
                item: response.data.data,
              }),
              (error) => ({ error }),
            );
          },
        };
      },
    };
  }
}
